/**
 * One-line summary of an attendance request's payload, as a reader in any language sees it.
 *
 * WorkerAttendanceRequests and WorkerAttendanceApprovals each had a copy. Both printed the raw
 * `2026-06-20 → 2026-06-22` and an English `3d`. Dates now go through the calendar-date formatter
 * (zone-safe) and the day count through the plural `common:daysCount`. The reason is the worker's
 * own words and is shown as typed.
 * Mobile twin: svdy-mobile/src/attendanceRequestDisplay.ts.
 */
import { fmtCalendarDate, fmtCalendarRange } from './datetime';

type T = (key: string, options?: Record<string, unknown>) => string;

export function attendanceDetailLine(
  data: Record<string, unknown> | null | undefined,
  t: T,
  locale?: string,
  { includeTime = false }: { includeTime?: boolean } = {},
): string {
  const d = data ?? {};
  const parts: string[] = [];
  const start = typeof d.start_date === 'string' ? d.start_date : undefined;
  const end = typeof d.end_date === 'string' ? d.end_date : undefined;
  const date = typeof d.date === 'string' ? d.date : undefined;
  if (start && end) parts.push(fmtCalendarRange(start, end, locale));
  else if (date) parts.push(fmtCalendarDate(date, locale));
  const days = typeof d.days === 'number' ? d.days : Number(d.days);
  if (d.days != null && d.days !== '' && Number.isFinite(days)) parts.push(t('common:daysCount', { count: days }));
  if (includeTime && d.time) parts.push(String(d.time));
  if (d.reason) parts.push(String(d.reason));
  return parts.join(' · ');
}
